import React, { useEffect, useState, useRef } from "react";

import { useLocation, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";

import WorkoutContent from "../components/WorkoutContent";
import WorkoutHeader from "../components/WorkoutHeader";
import { useWorkout } from "../hooks/workoutHook";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import { usePlan } from "../../plan/hooks/planHook";
import WorkoutTimer from "../components/WorkoutTimer";
import WorkoutBottomBar from "../components/WorkoutBottomBar";

export default function Workout() {
  const workoutContext = useWorkout();
  const planContext = usePlan();
  const { idWorkout, idSuperserie, idExercise } = useParams();
  const location = useLocation();
  const hash = location.hash

  const workout = workoutContext.workoutData.workout;

  const backTo = planContext.planData.id
    ? `/workout/${planContext.planData.id}/Content${hash}`
    : undefined;

  // Timer state
  const [showTimer, setShowTimer] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const timerRef = useRef(null);

  // Calculate total time in milliseconds when minutes or seconds change
  useEffect(() => {
    setTimeLeft(minutes * 60 + seconds);
  }, [minutes, seconds]);

  // Timer logic
  useEffect(() => {
    if (isRunning && timeLeft > 0) {
      timerRef.current = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    } else if (timeLeft === 0 && isRunning) {
      setIsRunning(true);
      setIsCompleted(true);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [isRunning, timeLeft]);

  // Update minutes and seconds display from timeLeft
  useEffect(() => {
    if (isRunning) {
      setMinutes(Math.floor(timeLeft / 60));
      setSeconds(timeLeft % 60);
    }
  }, [timeLeft, isRunning]);

  const handleStartStop = () => {
    if (minutes === 0 && seconds === 0 && !isRunning) {
      return; // Don't start if timer is at 0
    }
    setIsRunning(!isRunning);
    if (isCompleted) {
      setIsCompleted(false);
    }
  };

  const handleReset = () => {
    setIsRunning(false);
    setMinutes(0);
    setSeconds(0);
    setTimeLeft(0);
    setIsCompleted(false);
  };

  const onTimerClicked = () => {
    if (isRunning && timeLeft == 0) {
      setIsRunning(false);
      setIsCompleted(true);
    }
    setShowTimer(true);

  }

  const onRestClicked = (rest) => {
    if (isRunning && timeLeft > 0) {
      setShowTimer(true);
      return; // Don't allow rest if timer is running
    }
    if (rest) {
      const minutes = Math.floor(rest / 60);
      const seconds = rest % 60;
      setMinutes(minutes);
      setSeconds(seconds);
      setTimeLeft(rest);
      setIsCompleted(false);
      setShowTimer(true);
      setIsRunning(false);
    }
  }

  const onBottomBarClicked = () => {
    if (isRunning && timeLeft > 0) {
      setShowTimer(true);
      return; // Don't allow rest if timer is running
    }

    if (isRunning && timeLeft === 0) {
      setIsRunning(false);
      setIsCompleted(true);
    }
    setShowTimer(true);
  }

  const onTimerClose = () => {
    setShowTimer(false);
    if (isRunning && timeLeft === 0) {
      setIsRunning(false);
      setIsCompleted(true);
    }
  }


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [idWorkout, idSuperserie, idExercise]);

  return (
    <div>
      <WorkoutTimer
        show={showTimer}
        onClose={onTimerClose}
        minutes={minutes}
        seconds={seconds}
        isRunning={isRunning}
        isCompleted={isCompleted}
        timeLeft={timeLeft}
        setMinutes={setMinutes}
        setSeconds={setSeconds}
        setIsRunning={setIsRunning}
        setIsCompleted={setIsCompleted}
        handleStartStop={handleStartStop}
        handleReset={handleReset}
      />
      <WorkoutHeader
        title={workout.name}
        showInfo={true}
        backTo={backTo}
        image={workout.cover}
        onTimerClicked={onTimerClicked}
      />
      <ContainerResponsive>
        <Container className="mt-4" style={{ paddingBottom: isRunning ? 60 : 0 }}>
          <WorkoutContent workout={workout} onRestClicked={onRestClicked} isRestRunning={isRunning && timeLeft > 0} />
        </Container>
      </ContainerResponsive>
      {isRunning && (<WorkoutBottomBar minutes={minutes} seconds={seconds} onClicked={onBottomBarClicked} onClose={() => { setIsRunning(false) }} />)}
    </div>
  );
}
